// import React, { useState } from "react";
// import axios from "axios";
// import Style from "../Style/UserLogin.module.scss";
// import { FaEye, FaEyeSlash, FaSignInAlt } from "react-icons/fa";
// import { Link } from "react-router-dom";

// const UserLogin = ({ darkMode }) => {
//   const [formData, setFormData] = useState({ email: "", password: "" });
//   const [message, setMessage] = useState("");
//   const [showPassword, setShowPassword] = useState(false);

//   const handleChange = (e) => {
//     setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setMessage("");

//     try {
//       const res = await axios.post("http://localhost:5000/api/login", formData);
//       setMessage(res.data.message);
//       localStorage.setItem("token", res.data.token);
//     } catch (err) {
//       setMessage(err.response?.data?.error || "Something went wrong");
//     }
//   };

//   const togglePasswordVisibility = () => setShowPassword((prev) => !prev);

//   return (
//     <div className={`${Style.Registerlogin} ${darkMode ? Style.dark : ""}`}>
//       <div className={Style.wrapper}>
//         <div className={Style.RegisterDisklogin}>
//           <FaSignInAlt className={Style.LoginIcon} />
//           <h2>User Login</h2>
//         </div>

//         <div className={Style.RegisterFormlogin}>
//           <form onSubmit={handleSubmit} className={Style.Formlogin}>
//             <div className={Style.RegisterInputlogin}>
//               <input
//                 type="email"
//                 name="email"
//                 placeholder="Enter your email"
//                 value={formData.email}
//                 onChange={handleChange}
//                 required
//               />
//             </div>

//             <div
//               className={`${Style.RegisterInputlogin} ${Style.PasswordField}`}
//             >
//               <input
//                 type={showPassword ? "text" : "password"}
//                 name="password"
//                 placeholder="Enter your password"
//                 value={formData.password}
//                 onChange={handleChange}
//                 required
//               />
//               <span
//                 className={Style.ToggleIcon}
//                 onClick={togglePasswordVisibility}
//               >
//                 {showPassword ? <FaEyeSlash /> : <FaEye />}
//               </span>
//             </div>

//             <div className={Style.ForgotPasswordLink}>
//               <Link to="/forgot-password">Forgot Password?</Link>
//             </div>

//             <div className={Style.LoginSubmit}>
//               <button type="submit">Login</button>
//             </div>
//           </form>

//           {message && <p className={Style.Message}>{message}</p>}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default UserLogin;

import React, { useState } from "react";
import axios from "axios";
import Style from "../Style/UserLogin.module.scss";
import { FaEye, FaEyeSlash, FaSignInAlt, FaTimes } from "react-icons/fa";
import { Link } from "react-router-dom";

const UserLogin = ({ darkMode, isOverlay = false, onLoginSuccess }) => {
  const [formData, setFormData] = useState({ email: "", password: "" });
  const [message, setMessage] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const baseURL = process.env.REACT_APP_BASE_URL;

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");

    try {
      const res = await axios.post(`${baseURL}/api/login`, formData);
      setMessage(res.data.message);
      localStorage.setItem("token", res.data.token);
      if (onLoginSuccess) onLoginSuccess();
    } catch (err) {
      setMessage(err.response?.data?.error || "Something went wrong");
    }
  };

  const togglePasswordVisibility = () => setShowPassword((prev) => !prev);

  const loginForm = (
    <form onSubmit={handleSubmit} className={Style.Formlogin}>
      <div className={Style.RegisterInputlogin}>
        <input
          type="email"
          name="email"
          placeholder="Enter your email"
          value={formData.email}
          onChange={handleChange}
          required
        />
      </div>

      <div className={`${Style.RegisterInputlogin} ${Style.PasswordField}`}>
        <input
          type={showPassword ? "text" : "password"}
          name="password"
          placeholder="Enter your password"
          value={formData.password}
          onChange={handleChange}
          required
        />
        <span className={Style.ToggleIcon} onClick={togglePasswordVisibility}>
          {showPassword ? <FaEyeSlash /> : <FaEye />}
        </span>
      </div>

      <div className={Style.ForgotPasswordLink}>
        <Link to="/forgot-password">Forgot Password?</Link>
      </div>

      <div className={Style.LoginSubmit}>
        <button type="submit">Login</button>
      </div>

      {message && <p className={Style.Message}>{message}</p>}
    </form>
  );

  if (isOverlay) {
    return (
      <div className={`${Style.Overlay} ${darkMode ? Style.dark : ""}`}>
        <div className={`${Style.DiskForm} ${darkMode ? Style.dark : ""}`}>
          <FaTimes className={Style.CloseIcon} onClick={onLoginSuccess} />

          <FaSignInAlt className={Style.LoginIcon} />
          <h2>User Login</h2>
          {loginForm}
        </div>
      </div>
    );
  }
  return (
    <div className={`${Style.Registerlogin} ${darkMode ? Style.dark : ""}`}>
      <div className={Style.wrapper}>
        <div className={Style.RegisterDisklogin}>
          <FaSignInAlt className={Style.LoginIcon} />
          <h2>User Login</h2>
        </div>
        <div className={Style.RegisterFormlogin}>{loginForm}</div>
      </div>
    </div>
  );
};

export default UserLogin;
